import { Button, Grid, Popover, Tooltip, Typography } from '@mui/material';
import moment from 'moment';
import React, { MouseEvent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Datatable, { PagingTypeEnum } from '../Datatable/Datatable';
import DatatableColumnModel from '../Datatable/DatatableColumnModel';
import { OrderDirection } from '../Datatable/OrderDirection';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import CompanyNameCombineModel from './models/CompanyNameCombineModel';
import { userProfileSelector } from '../Login/reducers/UserProfileReducer';
import Swal from 'sweetalert2';
import CompanyNameCombineApi, { DeleteCompanyNameCombineByIdParam } from './api/CompanyNameCombineApi';
import { CompanyNameCombineSearchSelector, setDatatableSelectedIndex, setSearchResults, setTriggerRefreshData } from './reducers/CompanyNameCombineSearchReducer';
import CargoTypeModel from '../CargoTypeSelector/models/CargoTypeModel';
import { CompanyNameCombineInputSelector, setSelectedCompanyNameCombineId, setTriggerRefreshCompanyNames } from './reducers/CompanyNameCombineInputReducer';

const CompanyNameCombineTable: React.FunctionComponent = () => {
    let dispatch = useDispatch();
    let history = useHistory();

    let CompanyNameCombineData = useSelector(CompanyNameCombineSearchSelector);
    const CompanyNameCombineInputViewData = useSelector(CompanyNameCombineInputSelector);

    useEffect(() => {
        CompanyNameCombineApi.GetAll()
            .then((response: BaseResponse<CompanyNameCombineModel[]>) => {
                if (response.success) {
                    dispatch(setSearchResults(response.data))
                } else {
                    Utility.Alert.Error(response.message);
                }
            }).catch((error) => {
                Utility.Alert.Error(error);
            })
    }, [CompanyNameCombineData.triggerRefreshData])

    const divRef = React.createRef<HTMLDivElement>();

    const columns = [
        {
            Field: Utility.propertyOf<CompanyNameCombineModel>("name"),
            Title: "Name",
            AllowSort: true,
        } as DatatableColumnModel<CompanyNameCombineModel>,
        {
            Field: Utility.propertyOf<CompanyNameCombineModel>("companyNames"),
            Title: "Company Name",
            AllowSort: true,
        } as DatatableColumnModel<CompanyNameCombineModel>,
        {
            Field: "",
            Title: "",
            AllowSort: true,
            Render: (rowData: CompanyNameCombineModel) => (
                <>
                    <Tooltip title="Delete CompanyNameCombine">
                        <Button
                            className='table-action-button'
                            variant='outlined'
                            color='error'
                            onClick={() => {
                                deleteCompanyNameCombine(rowData.id)
                            }}
                        >
                            <i className="fa fa-trash" aria-hidden="true"></i>
                        </Button>
                    </Tooltip>
                </>
            )
        } as DatatableColumnModel<CompanyNameCombineModel>,
    ];

    const deleteCompanyNameCombine = (id: string) => {
        Swal.fire({
            title: 'Are you sure want to delete this? This action can not be undone.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(showLoading(true));
                CompanyNameCombineApi.Delete({
                    id: id
                } as DeleteCompanyNameCombineByIdParam)
                    .then((response: BaseResponse<CompanyNameCombineModel>) => {
                        if (response.success) {
                            Utility.Alert.Success("Company Name Combine deleted successful");

                            dispatch(showLoading(false));

                            dispatch(setTriggerRefreshData(new Date().getTime()));
                            dispatch(setTriggerRefreshCompanyNames((new Date()).getTime()));
                        }
                    });
            }
        })
    }

    const getTableClassName = () => {
        let className = "CompanyNameCombine-datatable-search-result nice-scroll";

        if (!CompanyNameCombineInputViewData.companyNameCombineInputExpand) {
            className += " CompanyNameCombine-datatable-search-result-quick-input-collapse-only";
        }

        return className;
    }

    return <div className='datatable-wrapper'>
        <Datatable<CompanyNameCombineModel>
            useCheckBox={true}
            useDefaultSearchBar={false}
            pagingType={PagingTypeEnum.None}
            data={CompanyNameCombineData.searchResults}
            columns={columns}
            isDataLoaded={true}
            className={getTableClassName()}
            useHeaderSort={false}
            selectedRowIndex={CompanyNameCombineData.datatableSelectedIndex}
            stickyHeader={true}
            // orderColumn={CompanyNameCombineData.query.orderBy}
            // orderDirection={CompanyNameCombineData.query.orderDirection}
            onRowSelectedChange={(Fixture: CompanyNameCombineModel, index: number, event: MouseEvent<HTMLElement>) => {
                var target = event.target as HTMLElement;
                if (target.tagName !== "BUTTON") {
                    dispatch(setSelectedCompanyNameCombineId(Fixture.id))
                    dispatch(setDatatableSelectedIndex(index));
                }
            }}
        ></Datatable>
    </div>
};

export default CompanyNameCombineTable;